// material
import { Card, Container, Typography, Stack, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
// router
import { useParams } from 'react-router-dom';
// sections
import EditAdminForm from '../sections/form/EditAdminForm';
import EditUserForm from '../sections/form/EditUserForm';
import EditRegisterUserForm from '../sections/form/EditRegisterUserForm';

// components
import Page from '../components/Page';
import BasicBreadcrumb from '../components/BasicBreadcrumb';

const RootStyle = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center'
}));
const ContentStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  // maxWidth: '50%',
  margin: theme.spacing(2),
  display: 'flex',
  justifyContent: 'flex-end',
  flexDirection: 'column',
  padding: theme.spacing(2)
}));

import { useTranslation } from 'react-i18next';

export default function EditInfo({ title, identity }) {
  const { t } = useTranslation();
  const { adminId, id, registerUserId } = useParams();

  let bread = [];
  if (identity === 'admin') {
    bread = [
      <Link href={'/admin'} underline="hover" key="1" color="inherit">
        {t('admin.title')}
      </Link>,
      <Link href={`/admin/info/${adminId}`} underline="hover" key="2" color="inherit">
        {t('people.info_title', { identity: t('nav.admin') })}
      </Link>,
      <Typography key="3" color="text.primary">
        {t('common.edit')}
      </Typography>
    ];
  } else if (identity === 'user') {
    bread = [
      <Link href={'/user'} underline="hover" key="1" color="inherit">
        {t('user.title')}
      </Link>,
      <Link href={`/user/info/${id}`} underline="hover" key="2" color="inherit">
        {t('people.info_title', { identity: t('nav.users') })}
      </Link>,
      <Typography key="3" color="text.primary">
        {t('common.edit')}
      </Typography>
    ];
  } else if (identity === 'registerUser') {
    bread = [
      <Link href={'/register'} underline="hover" key="1" color="inherit">
        {t('nav.enroll')}
      </Link>,
      <Link href={`/register/info/${registerUserId}`} underline="hover" key="2" color="inherit">
        {t('people.info_title', { identity: t('nav.enroll') })}
      </Link>,
      <Typography key="3" color="text.primary">
        {t('common.edit')}
      </Typography>
    ];
  }

  const localizedTitle = t('people.edit_title', { identity: t(`nav.${identity === 'registerUser' ? 'enroll' : identity}`) });

  return (
    <Page title={localizedTitle}>
      <Container maxWidth={false}>
        <Stack direction="column">
          <Typography variant="h4" gutterBottom>
            {localizedTitle}
          </Typography>
          <BasicBreadcrumb bread={bread} />
        </Stack>

        <RootStyle>
          <ContentStyle>
            {identity === 'admin' && <EditAdminForm adminId={adminId} />}
            {identity === 'user' && <EditUserForm id={id} />}
            {identity === 'registerUser' && <EditRegisterUserForm registerUserId={registerUserId} />}
          </ContentStyle>
        </RootStyle>
      </Container>
    </Page>
  );
}
